import http from '~/common/http';

/**
 * 公用接口服务类
 * 所有公用接口都不受权限控制，适用于渲染公用组件的场景
 */
export default {
    /** 获取校本2.0 应用列表 */
    getJbApp(params) {
        return http.get('api/common/get-app', {});
    },

    /** 获取校本3.0 应用列表 */
    getJbtAPP(params) {
        return http.get('api/common/get-school-app', {params: params});
    },

    /** 获取数字化校园所有app */
    getAllAPP(params = {}) {
        return http.get('api/common/get-all-app', {params: params});
    },

    /**
     * 获取学校产品信息
     */
    getSchoolProductInfo(params) {
        return http.get('api/school/get-school-product-info', {params: params});
    },

    /**
     *获取合作方信息
     */
    getCorpInfo(params){
        return http.get('api/school/get-school-corp-info', {params: params});
    },
    /**
     * 获取产品配置使用情况
     */
    getConfigUse(params){
        return http.get('api/school/get-product-used', {params: params});
    },

    /** 检测域名是否存在
     * 校本，
     * 校本3.0
     * 门户官网，
     * 数字化校园，
     * 组卷合作机构
     * 都会使用到此接口
     */
    checkUrlIsExist(params) {
        return http.get('api/school/check-url-is-exist', {params: params});
    },

    /**
     * 获取所有产品
     * @param params
     * @returns {*}
     */
    getProducts(params) {
        return http.get('/api/common/get-products', {
            params: params
        });
    },

    /**
     * 获取产品类型
     * @param params
     * @returns {*}
     */
    getProductType(params) {
        return http.get('/api/common/get-products-type');
    },

    /**
     * 得到所有客户跟进记录
     * @param params
     * @returns {*}
     */
    getCustomerTraces(params) {
        return http.get('/api/common/get-customer-traces', {
            params: params
        });
    },

    /**
     * 获取所有客户
     * @param params
     * @returns {*}
     */
    getCustomers(params) {
        return http.get('/api/common/get-customers', {
            params: params
        });
    },

    /**
     * 获取所有客户
     * @param params
     * @returns {*}
     */
    getCustomerList(params) {
        return http.get('/api/common/customer-list', {
            params: params
        });
    },
    /**
     * 通过Es获取所有客户
     * @param params
     * @returns {*}
     */
    getCustomersByEs(params) {
        return http.get('/api/common/get-customers-by-es', {
            params: params
        });
    },

    /**
     * 获取所有联系人
     * @param params
     * @returns {*}
     */
    getContacts(params) {
        return http.get('/api/common/get-contact-all', {
            params: params
        });
    },

    //用于获取续约目标列表
    getTargetOrder(params){
        return http.get('/api/common/get-target-order', {
            params: params
        });
    },

    getPayment(params) {
        return http.get('/api/common/payment', {
            params: params
        });
    },

    /**
     * 得到所有销售线索
     * @param params
     * @returns {*}
     */
    getSaleLeads(params) {
        return http.get('/api/common/get-sales-leads', {
            params: params
        });
    },

    /**
     * 获取所有角色信息
     * @returns {*}
     */
    getAllRoles() {
        return http.get('api/common/roles')
    },

    /**
     * 获取所有部门信息
     * @returns {*}
     */
    getAllBranches(params = []) {
        return http.get('api/common/branches', {
            params: params
        });
    },

    /**
     * 得到末级节点部门(也就是其下没有子部门)
     * @returns {*}
     */
    getLastBranches() {
        return http.get('api/common/last-branches');
    },

    /**
     * 获取所有学科
     */
    getAllSubjects()
    {
        return http.get('api/common/get-all-subjects');
    },


    /**
     * 根据用户参数获取绑定学科
     */
    getBindSubject(params) {
        return http.get('/api/common/get-bind-subjects', {
            params: params
        });
    },
    /**
     * 根据客户id和产品id获取排课查询密码
     */
    getQueryCode(params) {
        return http.get('/api/common/get-query-code', {
            params: params
        });
    },
    /**
     * 根据客户id和产品id获取排课查询密码
     */
    getTimeTableInfo(params) {
        return http.get('/api/common/get-time-table-info-by-customer-id', {
            params: params
        });
    },
    /**
     * 试用订单提交需要审核提示
     */
    tipAudit(params) {
        return http.post('/api/common/tip-audit', params);
    },

    /**
     * 删除新版排课学校配置
     */
    deletePaike(schoolId) {
        return http.delete('/api/common/delete-paike', {
            params: {
                schoolId: schoolId
            }
        });
    },

    /**
     * 线索操作日志
     */
    getSalesLogs(params) {
        return http.get('/api/common/get-sales-logs', {
            params : params
        });
    },

    /**
     * 获取全国地区树
     */
    getAreaTree(params) {
        return http.get('/api/common/get-area-tree', {
            params : params
        });
    },

    /**
     * 获取指定地区信息-列表
     */
    getDistricts(ids) {
        return http.post('/api/common/get-districts', {ids: ids});
    },


    /**
     * 设置用户缓存
	 */
	setUserCache(params) {
        return http.put('/api/common/set-user-cache', params);
    },

    /**
     * 订单合同盖章信息
	 */
	getOrderContractSeal(params) {
        return http.get('/api/common/get-order-contract-seal', {
            params : params
        });
    },

    /**
     * 订单发票列表
	 */
	getOrderInvoice(params) {
        return http.get('/api/common/get-order-invoice', {
            params : params
        });
    },


    /**
     * 获取部门领导人
	 */
	getBranchLeader(params) {
        return http.get('/api/common/branch-leader', {
            params : params
        });
    },

    /**
     * 获取集团校列表
	 */
	getCorpList(params) {
        return http.get('/api/common/get-corp-list', {
            params : params
        });
    },


    /**
     * 获取订单地址
	 */
	getOrderAddress(params) {
        return http.get('/api/common/get-order-address', {
            params : params
        });
    },

}


// WEBPACK FOOTER //
// ./src/services/common.js